import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VSelect, {
    attrs: {
      items: _vm.mapeamentos,
      "item-text": "nome",
      "item-value": "id",
      label: "Mapeamento:",
      "return-object": "",
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c("span", [_vm._v(_vm._s(item.nome))]),
            item.mapeamentoImportado
              ? _c(
                  VChip,
                  {
                    staticClass: "ml-2",
                    attrs: { color: "success", outlined: "", "x-small": "" },
                  },
                  [_vm._v(" Importado ")]
                )
              : _vm._e(),
          ]
        },
      },
      {
        key: "selection",
        fn: function ({ item }) {
          return [
            _c("span", [_vm._v(_vm._s(item.nome))]),
            item.mapeamentoImportado
              ? _c(
                  VChip,
                  {
                    staticClass: "ml-2",
                    attrs: { color: "success", outlined: "", "x-small": "" },
                  },
                  [_vm._v(" Importado ")]
                )
              : _vm._e(),
          ]
        },
      },
    ]),
    model: {
      value: _vm.mapeamentoSelecionado,
      callback: function ($$v) {
        _vm.mapeamentoSelecionado = $$v
      },
      expression: "mapeamentoSelecionado",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }